import React from 'react';
import { CompassIcon, GaugeIcon, CalendarCheckIcon, UsersIcon, WalletIcon } from 'lucide-react';
import { BookingButton } from '../components/BookingButton';
import { Accordion } from '../components/Accordion';
import { FooterCTA } from '../components/FooterCTA';
import { testimonials } from '../components/testimonials';
import { TestimonialCard } from '../components/TestimonialCard';
export function ProviToolkit() {
  const faqs = [{
    question: 'În ce format primesc instrumentele?',
    answer: 'Primești acces imediat după plată la un folder cu toate fișierele în format Google Docs și Google Sheets, gata de copiat și personalizat. Lecțiile video sunt accesibile online, pe platforma ProVi, fără limită de timp.'
  }, {
    question: 'Trebuie să am cunoștințe tehnice ca să le folosesc?',
    answer: 'Nu. Fiecare instrument vine cu un ghid video în care Valer explică pas cu pas cum se completează și cum se citesc rezultatele. Dacă știi să folosești Google Docs și Google Sheets, ești gata.'
  }, {
    question: 'Cât timp îmi ia să aplic toate instrumentele?',
    answer: 'Poți aplica primul instrument, Organizatorul Viziune și Strategie, în prima zi. Toolkit-ul complet se implementează gradual în 2 până la 4 săptămâni, câte un instrument pe săptămână, fără să îți perturbe activitatea curentă.'
  }, {
    question: 'Funcționează și dacă am o echipă mică, de 3 până la 5 oameni?',
    answer: 'Da, de fapt pentru echipele mici impactul este cel mai rapid vizibil. Cu cât echipa e mai mică, cu atât un instrument simplu de urmărire și un ritm de ședință clar fac o diferență imediată.'
  }, {
    question: 'Pot folosi aceste instrumente și cu echipa mea de lideri?',
    answer: 'Exact pentru asta sunt gândite. Tabela de marcaj, modelul de ședință și radarul oamenilor sunt instrumente de echipă, nu individuale. Le introduci în ședința ta săptămânală și le completați împreună.'
  }, {
    question: 'Ce se întâmplă dacă vreau mai mult după ce aplic toolkit-ul?',
    answer: 'ProVi Toolkit este primul nivel din ecosistemul ProVi System. Dacă după aplicare simți că ai nevoie de implementare mai profundă, poți accesa workshopul, programul de grup sau implementarea completă de 12 luni. Suma plătită pe toolkit se deduce din investiția în programele superioare.'
  }];
  return <div className="w-full min-h-screen bg-[#09111F] overflow-x-hidden pt-20" data-id="element-836" data-mp="11ftnkrv0531l">
      {/* SECTION 1 — HERO */}
      <section className="w-full bg-[#09111F] relative overflow-hidden py-20 md:py-32" data-id="element-837" data-mp="1f6ypk0lue7f3">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12 relative z-10" data-id="element-838" data-mp="1b6oei9j70qtd">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-839" data-mp="1p5wgfa6qqd19">
            <div className="text-center" data-id="element-840" data-mp="1p54pwds035hu">
              <div className="inline-flex items-center gap-2 bg-[rgba(29,78,216,0.15)] border border-[rgba(29,78,216,0.3)] px-4 py-2 rounded-full mb-8" data-id="element-841" data-mp="1k6beqs06rqku">
                <span className="font-['Montserrat'] text-[11px] font-bold tracking-[0.15em] uppercase text-[#3B82F6]" data-id="element-842" data-mp="3qxj7tcujo9y9">
                  PRODUS DIGITAL
                </span>
              </div>
              <h1 className="font-['Montserrat'] text-[clamp(40px,5vw,64px)] font-extrabold text-white leading-[1.1] mb-6" data-id="element-843" data-mp="21gxet9ir89ec">
                ProVi Toolkit
              </h1>
              <p className="font-['Inter'] text-[20px] md:text-[24px] font-light text-[rgba(255,255,255,0.8)] leading-[1.6] mb-10" data-id="element-844" data-mp="1rpaywzvh1m59">
                Instrumentele simple, clare, aplicabile de azi, cu care pui
                ordine în afacere!
              </p>
              <BookingButton text="Vreau ProVi Toolkit" className="px-10 py-5 text-[16px]" data-id="element-845" data-mp="1noqwbgs4pqbq" />
            </div>
            <div className="relative hidden md:block" data-id="element-846" data-mp="18rzxp9qa4in6">
              <div className="absolute inset-0 bg-[#1D4ED8] opacity-20 blur-[60px] rounded-full" data-id="element-847" data-mp="18tazx542tic6"></div>
              <img src="https://cdn.magicpatterns.com/uploads/1qDFDp65YrcKUVLXFgRA4a/Toolkit_Provisystem_-_Produs_Patrat_sus.png" alt="Instrumentele ProVi Toolkit" className="relative z-10 w-full rounded-2xl border-2 border-[rgba(255,255,255,0.1)] shadow-2xl object-cover aspect-square" data-id="element-848" data-mp="1dsnmdor1cne8" />
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 2 — DESCRIERE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-849" data-mp="14199nrnhg4v8">
        <div className="max-w-[800px] mx-auto px-5 md:px-12" data-id="element-850" data-mp="z14x2cpp3uaa">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-8 text-center" data-id="element-851" data-mp="z3hfeqzd86nv">
            Știi că ceva nu funcționează cum trebuie. Dar nu știi de unde să
            începi.
          </h2>
          <div className="space-y-6 font-['Inter'] text-[18px] text-[#4B5563] leading-[1.8]" data-id="element-852" data-mp="kc8jk04vdp2a">
            <p data-id="element-853" data-mp="gawz090uru0y">
              Ești antreprenor sau lider de departament cu rezultate decente,
              dar simți că afacerea sau echipa ta funcționează haotic. Nu ai o
              direcție scrisă pe care toată lumea să o urmeze.
            </p>
            <p data-id="element-854" data-mp="6c7iokoluhmt">
              Nu ai cifre clare urmărite săptămânal. Ședințele se țin, dar nu se
              termină cu nimic concret. Aceleași probleme revin lună după lună.
            </p>
            <p data-id="element-855" data-mp="3nettmhn1x4sp">
              Fără instrumente clare, haosul devine norma. Fiecare zi se consumă
              în urgențe, nu în direcție. Echipa improvizează pentru că nu are
              un cadru. Tu improvizezi pentru că nu ai timp să construiești
              unul.
            </p>
            <p className="font-bold text-[#09111F]" data-id="element-856" data-mp="65x5wc8o4cpg">
              ProVi Toolkit este setul de instrumente practice extrase direct
              din ProVi System, gândit pentru antreprenorul care vrea să înceapă
              să pună ordine singur, fără consultant.
            </p>
            <p data-id="element-857" data-mp="3emrucmopxuk0">
              Primești lecțiile video care explică fiecare unealtă și
              template-urile gata de folosit pentru viziune, oameni, cifre și
              ritm de ședințe. Descarci, urmezi pașii și aplici de azi.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 3 — CE PRIMEȘTI */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-858" data-mp="2qvmisjpt9ofi">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-859" data-mp="2ivzoqfuzquyh">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-16 text-center" data-id="element-860" data-mp="2dxog28gfmqhu">
            Ce primești în ProVi Toolkit și la ce îți folosește fiecare
            instrument
          </h2>
          <div className="space-y-6" data-id="element-861" data-mp="2nn7yxe45akcp">
            {[{
            title: 'Organizatorul Viziune & Strategie',
            Icon: CompassIcon,
            items: ['Template structurat în care documentezi direcția companiei, obiectivele anului și prioritățile trimestrului curent', 'Ghid video pas cu pas care îți explică cum să completezi viziunea astfel încât să poată fi comunicată și urmărită de toată echipa', 'Format gata de prezentat în prima ședință cu liderii tăi, fără pregătire suplimentară']
          }, {
            title: 'Tabela de Marcaj & Lista de Probleme',
            Icon: GaugeIcon,
            items: ['Tablou de bord săptămânal care îți arată în 10 minute cifrele care contează și abaterile față de target', 'Sistem simplu de înregistrare a problemelor recurente cu câmpuri pentru cauză, responsabil și termen de rezolvare', 'Video de introducere care îți explică ce indicatori să urmărești în funcție de etapa afacerii tale']
          }, {
            title: 'Modelul de Ședință Puls 10 & Planul Trimestrial',
            Icon: CalendarCheckIcon,
            items: ['Agendă standard pentru ședința săptămânală de echipă de 10 minute cu structură fixă: cifre, probleme, priorități, asumare', 'Template de plan trimestrial cu obiectiv principal, priorități și acțiuni cu responsabili și termene clare', 'Video care arată cum să conduci prima ședință Puls 10 astfel încât echipa să adopte ritmul fără rezistență']
          }, {
            title: 'Radarul Oamenilor Potriviți',
            Icon: UsersIcon,
            items: ['Diagramă vizuală în care plasezi fiecare om din echipă în funcție de aliniere la valori și la cerințele rolului', 'Ghid de interpretare care îți explică ce înseamnă fiecare zonă a radarului și ce decizie urmează în fiecare caz', 'Video în care Valer explică cele mai frecvente greșeli de plasare a oamenilor în roluri și cum să le eviți']
          }, {
            title: 'Instrumentul de Urmărire Cash',
            Icon: WalletIcon,
            items: ['Tablou simplu de urmărire a intrărilor, ieșirilor și marjelor cu vizualizare lunară și trimestrială', 'Câmpuri predefinite pentru cele mai importante categorii de costuri și venituri din orice tip de afacere', 'Video scurt care îți arată cum să citești tabloul în 5 minute și ce decizie implică fiecare scenariu']
          }].map((block, i) => <div key={i} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100" data-id="element-862" data-mp="iejtblcw7630" data-mpi={i}>
                <div className="flex items-center gap-5 bg-[#09111F] px-6 md:px-8 py-5" data-id="element-863" data-mp="dje70lfkvpee">
                  <div className="w-12 h-12 rounded-xl bg-[#1D4ED8] flex items-center justify-center flex-shrink-0" data-id="element-864" data-mp="337x1oxj1jeaf">
                    <block.Icon className="w-6 h-6 text-white" strokeWidth={2} aria-hidden="true" data-id="element-865" data-mp="2y9vhg99vp8xd" />
                  </div>
                  <h3 className="font-['Montserrat'] text-[19px] md:text-[22px] font-bold text-white leading-tight" data-id="element-866" data-mp="1io1n7d3eq19t">
                    {block.title}
                  </h3>
                  <span className="ml-auto font-['Montserrat'] text-[28px] font-extrabold text-white/15 leading-none hidden sm:block" data-id="element-867" data-mp="1nlupvw5i4d5c">
                    0{i + 1}
                  </span>
                </div>
                <ul className="divide-y divide-gray-100" data-id="element-868" data-mp="21f2j1s98dgp5">
                  {block.items.map((item, j) => <li key={j} className="flex items-start gap-4 px-6 md:px-8 py-5" data-id="element-869" data-mp="21gx73ffstoxg" data-mpi={j}>
                      <div className="w-6 h-6 rounded-full bg-[#EFF6FF] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-870" data-mp="26c2oq2264hfq">
                        <div className="w-2 h-2 rounded-full bg-[#1D4ED8]" data-id="element-871" data-mp="c0e9dys0ycut"></div>
                      </div>
                      <span className="font-['Inter'] text-[16px] text-[#4B5563] leading-[1.7]" data-id="element-872" data-mp="gypgi1qxq99c">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 4 — BENEFICII */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-873" data-mp="3lmlyyhkn0kmw">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-874" data-mp="3lp898oywxe8t">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-16 text-center" data-id="element-875" data-mp="3ppic3srerojg">
            Ce obții concret cu ProVi Toolkit
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 items-stretch" data-id="element-876" data-mp="3gzb5dx75g7e">
            {[{
            title: 'Claritate în 30 de minute',
            desc: 'Organizatorul Viziune și Strategie se completează într-o singură sesiune și îți dă imediat o direcție documentată, comunicabilă și urmăribilă de toată echipa.'
          }, {
            title: 'Control săptămânal fără efort',
            desc: 'Tabela de marcaj se actualizează în 10 minute pe săptămână și îți arată tot ce trebuie să știi despre starea afacerii tale.'
          }, {
            title: 'Ședințe care produc rezultate',
            desc: 'Modelul Puls 10 transformă ședințele haotice în întâlniri scurte, concentrate și cu acțiuni clare asumate de fiecare participant.'
          }, {
            title: 'Echipă în rolurile potrivite',
            desc: 'Radarul Oamenilor Potriviți îți arată în câteva minute unde sunt nepotrivirile din echipă care te costă timp și energie în fiecare lună.'
          }, {
            title: 'Cash sub control',
            desc: 'Instrumentul de urmărire cash elimină surprizele financiare și îți dă curajul să iei decizii de creștere pe cifre reale, nu pe estimări.'
          }, {
            title: 'Lecții video care explică totul pas cu pas',
            desc: 'Nu primești template-uri goale. Primești lecțiile video în care Valer explică exact cum și când se aplică fiecare instrument.'
          }].map((benefit, i) => <div key={i} className="group relative flex flex-col bg-[#F8FAFC] rounded-2xl p-7 border-t-2 border-[#E2E8F0] hover:border-[#1D4ED8] hover:bg-white hover:shadow-[0_12px_30px_rgba(9,17,31,0.07)] transition-[background-color,border-color,box-shadow] duration-200 ease-out" data-id="element-877" data-mp="34c8ehzpktl8a" data-mpi={i}>
                <span className="font-['Montserrat'] text-[13px] font-extrabold tracking-[0.2em] text-[#1D4ED8] mb-4" data-id="element-878" data-mp="3egyjyfk6v7h9">
                  0{i + 1}
                </span>
                <h3 className="font-['Montserrat'] text-[19px] font-bold text-[#09111F] mb-3 leading-snug" data-id="element-879" data-mp="34j0trmirr0m0">
                  {benefit.title}
                </h3>
                <p className="font-['Inter'] text-[15px] text-[#4B5563] leading-[1.7]" data-id="element-880" data-mp="39gkbiweodvip">
                  {benefit.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 5 — CINE SUNT EU */}
      <section className="w-full bg-[#0A1628] py-16 md:py-24 text-white" data-id="element-881" data-mp="tr93xz7r1fmz">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-882" data-mp="xt47lad5k53x">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-883" data-mp="xsb5wnt1w5sn">
            <div className="relative" data-id="element-884" data-mp="2ic6k074rvgsq">
              <div className="absolute inset-0 bg-[#1D4ED8] opacity-20 blur-[60px] rounded-full" data-id="element-885" data-mp="2i9296qwsxmt3"></div>
              <picture data-id="element-886" data-mp="2e7gq2ntoccag">
                <source media="(min-width: 768px)" srcSet="https://cdn.magicpatterns.com/uploads/2MhFtrnAX7oE6puKbX6fNU/Valer_Dura_-_Acasa_Despre_Mine.png" data-id="element-887" data-mp="2s0ogic60r1qk" />
                <img src="https://cdn.magicpatterns.com/uploads/uMMs8znHdFM4A4yq1dSeTD/Valer_Dura_-_Acasa_Despre_Mine_Mobil.png" alt="Valer Dura" className="relative z-10 w-full max-w-[450px] mx-auto rounded-2xl border-2 border-[rgba(255,255,255,0.1)] shadow-2xl object-cover" data-id="element-888" data-mp="2n8wxcmp6zyag" />
              </picture>
            </div>
            <div data-id="element-889" data-mp="3axg7z8vpsn5p">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold mb-8 text-left" data-id="element-890" data-mp="360pp6dsizdgl">
            Cine a construit aceste instrumente și de ce poți să ai încredere în
            ele
          </h2>
          <div className="space-y-6 font-['Inter'] text-[18px] font-light text-[rgba(255,255,255,0.8)] leading-[1.8]" data-id="element-891" data-mp="1bn818po7kel1">
            <p data-id="element-892" data-mp="1e0bjzpvlmlom">
              Sunt Valer Dura. Am construit, eficientizat și vândut propriile
              afaceri cu cifre de milioane de euro. Nu am inventat aceste
              instrumente citind cărți de business. Le-am construit și rafinat
              în 12 ani de lucru direct cu antreprenori și echipe de lideri din
              companii românești reale.
            </p>
            <p data-id="element-893" data-mp="udvygv4o4zx4">
              ProVi Toolkit nu este o colecție de template-uri descărcate de pe
              internet și rebranduite. Este setul exact de instrumente pe care
              îl folosesc în programul de implementare de 12 luni cu clienții
              mei, simplificat pentru a fi aplicabil de oricine, fără să fie
              nevoie de un implementator alături.
            </p>
            <p data-id="element-894" data-mp="bneaf3us6si3">
              Am ales să scot aceste instrumente ca produs separat pentru că
              știu că există antreprenori care nu sunt pregătiți încă pentru un
              program complet, dar care au nevoie imediat de un punct de plecare
              concret. ProVi Toolkit este acel punct de plecare.
            </p>
          </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 6 — PENTRU CINE ESTE / NU ESTE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-895" data-mp="3vbhizruzfba0">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-896" data-mp="3q9s584gdkji8">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-897" data-mp="3m8q7xt60qhiw">
            <div className="bg-[#EFF6FF] rounded-3xl p-8 border border-[rgba(59,130,246,0.2)]" data-id="element-898" data-mp="3mab1bfgljuf6">
              <h3 className="font-['Montserrat'] text-[24px] font-bold text-[#09111F] mb-6" data-id="element-899" data-mp="3hgynm0dgh817">
                ProVi Toolkit este pentru tine dacă
              </h3>
              <ul className="space-y-4" data-id="element-900" data-mp="37kvda78ga336">
                {['Ești antreprenor cu echipă și lucrezi mult, dar fără o direcție clară documentată', 'Ești lider de departament care vrea un sistem simplu de urmărire a echipei și a rezultatelor', 'Vrei să pui ordine în afacere singur, fără să angajezi un consultant în această etapă'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-901" data-mp="2nwqvgl3enxi3" data-mpi={i}>
                    <div className="w-2 h-2 rounded-full bg-[#1D4ED8] mt-2 flex-shrink-0" data-id="element-902" data-mp="2sxn57fafudvf"></div>
                    <span className="font-['Inter'] text-[17px] text-[#4B5563] leading-[1.6]" data-id="element-903" data-mp="2eydsiplfy1w7">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
            <div className="bg-[#FEF2F2] rounded-3xl p-8 border border-[rgba(239,68,68,0.2)]" data-id="element-904" data-mp="37nca9llnj20z">
              <h3 className="font-['Montserrat'] text-[24px] font-bold text-[#09111F] mb-6" data-id="element-905" data-mp="3bmthajgq8789">
                ProVi Toolkit nu este pentru tine dacă
              </h3>
              <ul className="space-y-4" data-id="element-906" data-mp="32vkr3w4trykv">
                {['Ești la primul angajat sau nu ai echipă, instrumentele nu au unde să se aplice încă', 'Cauți o soluție care să funcționeze fără niciun efort de implementare din partea ta', 'Ai nevoie de cineva care să vină în compania ta și să facă schimbările alături de echipă'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-907" data-mp="8khw1m7ussly" data-mpi={i}>
                    <div className="w-2 h-2 rounded-full bg-[#EF4444] mt-2 flex-shrink-0" data-id="element-908" data-mp="4jo7cqml79s0"></div>
                    <span className="font-['Inter'] text-[17px] text-[#4B5563] leading-[1.6]" data-id="element-909" data-mp="ib34e1dbxbi2">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7 — RECAPITULARE INVESTIȚIE */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-910" data-mp="3hq7vyqgqb27g">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-911" data-mp="3hrssumqimx8h">
          <div className="bg-white rounded-3xl p-8 md:p-12 border-2 border-[#1D4ED8] shadow-[0_20px_40px_rgba(29,78,216,0.08)] relative" data-id="element-912" data-mp="3vq95svez1jz2">
            <div className="absolute -top-4 inset-x-0 flex justify-center" data-id="element-913" data-mp="3qpl7dooey0ut">
              <span className="bg-[#1D4ED8] text-white font-['Montserrat'] text-[12px] font-bold tracking-[0.15em] uppercase px-6 py-2 rounded-full shadow-md" data-id="element-914" data-mp="1aygsrb2yoyqk">
                RECAPITULARE
              </span>
            </div>
            <h2 className="font-['Montserrat'] text-[28px] md:text-[36px] font-bold text-[#09111F] mb-8 text-center mt-4" data-id="element-915" data-mp="30esu7me26k2o">
              Hai să recapitulăm ce primești și cât investești pentru ProVi
              Toolkit
            </h2>

            <div className="flex flex-col gap-10" data-id="element-916" data-mp="3e8twur84sr8b">
              <div data-id="element-917" data-mp="3e9lgr4sd90ir">
                <h3 className="font-['Montserrat'] text-[20px] font-bold text-[#1D4ED8] mb-6" data-id="element-918" data-mp="3ea526vh8671j">
                  Ce este inclus:
                </h3>
                <ul className="space-y-4" data-id="element-919" data-mp="3o5f4zlfg6igd">
                  {['Organizatorul Viziune & Strategie cu ghid video (Valoare: 59 €)', 'Tabela de Marcaj & Lista de Probleme cu video de introducere (Valoare: 59 €)', 'Modelul de Ședință Puls 10 & Planul Trimestrial cu video de facilitare (Valoare: 59 €)', 'Radarul Oamenilor Potriviți cu ghid de interpretare și video (Valoare: 59 €)', 'Instrumentul de Urmărire Cash cu video de citire (Valoare: 59 €)'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-920" data-mp="22uygxg9ekeg1" data-mpi={i}>
                      <svg className="w-5 h-5 text-[#1D4ED8] flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-921" data-mp="1vb715xkisl5c">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-922" data-mp="1ljsy5ftd137g"></path>
                      </svg>
                      <span className="font-['Inter'] text-[16px] text-[#4B5563] leading-[1.6]" data-id="element-923" data-mp="1gm168lspth39">
                        {item}
                      </span>
                    </li>)}
                </ul>
                <p className="font-['Montserrat'] text-[18px] font-bold text-[#6B7280] mt-6" data-id="element-924" data-mp="29aoxqz4252p9">
                  Valoare totală reală: 295 € dacă ai cumpăra fiecare instrument
                  separat
                </p>
              </div>
              <div data-id="element-925" data-mp="20b1su3c4derg">
                <div className="bg-[#FEF2F2] rounded-xl p-6 border border-[rgba(239,68,68,0.2)] text-center" data-id="element-926" data-mp="suvt4ee5t2wn">
                  <p className="font-['Montserrat'] text-[14px] font-bold text-[#EF4444] uppercase tracking-wider mb-2" data-id="element-927" data-mp="ot0r17oemlht">
                    PREȚUL SPECIAL:
                  </p>
                  <p className="font-['Montserrat'] text-[56px] font-extrabold text-[#09111F] leading-none" data-id="element-928" data-mp="3gjq041mcfgpj">
                    97 €
                  </p>
                  <p className="font-['Inter'] text-[15px] text-[#6B7280] mt-2" data-id="element-929" data-mp="3bl69vp0pvird">
                    în loc de 295 €
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-12 text-center" data-id="element-930" data-mp="83edlyfjscnd">
              <BookingButton text="Cumpără Acum ProVi Toolkit" className="px-10 py-5 text-[16px] w-full sm:w-auto" data-id="element-931" data-mp="3533rnp96255" />
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 8 — TESTIMONIALE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-932" data-mp="3qac8barqd4y7">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-933" data-mp="3qbvoz2hati0i">
          <div className="text-center mb-16" data-id="element-934" data-mp="2ju8jirltoa92">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F]" data-id="element-935" data-mp="2euduyupirwr6">
              Ce spun antreprenorii care folosesc instrumentele ProVi System
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-936" data-mp="zb6gglg3eawx">
            {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-937" data-mp="z9273nzfcjp9" data-mpi={i} />)}
          </div>
        </div>
      </section>

      {/* SECTION 9 — ÎNTREBĂRI FRECVENTE */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-938" data-mp="18402r2tyiaka">
        <div className="max-w-[800px] mx-auto px-5 md:px-12" data-id="element-939" data-mp="1d2tfuu5bzzjx">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-12 text-center" data-id="element-940" data-mp="1d2b7iz5e9uvn">
            Întrebări Frecvente
          </h2>
          <Accordion items={faqs} data-id="element-941" data-mp="1n0r0z8rw9g8b" />
        </div>
      </section>

      <FooterCTA data-id="element-942" data-mp="1mz63pbe73j6r" />
    </div>;
}